import * as React from 'react';

export default function usePromise<T>(prom: Promise<T>): T | null {
  const [r, set] = React.useState<T | null>(null);
  React.useEffect(() => {
    let active = true;
    prom.then((c) => active && set(c));
    return () => {
      active = false;
    };
  }, [prom]);
  return r;
}
